.fo{border:1px solid #ddd;}